export default {
    methods: {
        postToUrl(path, params, method = 'post')
        {
            var form = document.createElement("form");
            form.setAttribute("method", method);
            form.setAttribute("action", path);

            let hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", '_token');
            hiddenField.setAttribute("value", $("meta[name='csrf-token']").attr("content"));

            form.appendChild(hiddenField);

            for(var key in params) {

                if(params.hasOwnProperty(key)) {
                    let hiddenField = document.createElement("input");
                    hiddenField.setAttribute("type", "hidden");
                    hiddenField.setAttribute("name", key);
                    hiddenField.setAttribute("value", params[key]);

                    form.appendChild(hiddenField);
                 }
            }

            document.body.appendChild(form);
            form.submit();
        }
    }
}
